import { IExtractTask } from '../types/IExtractTask';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { INamedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetExtractTasksResult extends IGetItemsResult {
  tasks: IExtractTask[];
  datasources?: INamedItem[];
  workbooks?: INamedItem[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
}

export class GetExtractTasksRequest extends Request<IGetItemsParams, IGetExtractTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getExtractTasks', params);
  }
}
